import * as React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';

const AgyleLoadingSpinner = (props) => {
    const {t} = useTranslation();

    return (
        <div
            style={{textAlign: props.textAlign, fontWeight: 'bold'}}
            className={props.className}
        >
            <h2>{!props.disableText && t(props.label)}</h2>
            <CircularProgress size={props.spinnerSize}/>
        </div>
    );
};

export default AgyleLoadingSpinner;

AgyleLoadingSpinner.propTypes = {
    label: PropTypes.string,
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    className: PropTypes.any,
    spinnerSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disableText: PropTypes.bool,
};

AgyleLoadingSpinner.defaultProps = {
    label: 'Loading data. Please wait.',
    textAlign: 'center',
    disableText: false,
};